import axios from "axios";
import { useCallback, useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function useSpots() {
  const [spots, setSpots] = useState({ total: 20, taken: 0, remaining: 20 });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/spots");
      setSpots(data);
    } catch (e) {
      console.error("Failed to fetch spots", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { spots, loading, refresh, setSpots };
}
